/** Allowed density values for the Table component. */
export const TABLE_DENSITIES = Object.freeze(['compact', 'comfortable', 'spacious']);

/** Allowed alignment values for table cell components. */
export const TABLE_ALIGNMENTS = Object.freeze(['left', 'center', 'right', 'justify', 'char']);
